import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    reportTitle: {
        fontSize: 10,
        marginTop: 5,
        // fontWeight:'bold',
        fontFamily: 'Helvetica-Bold',
        textIndent: '5px'
    },
    fragmentContainer: {
        // marginTop: '15px',
        width: '100%',
        flexDirection: 'row',
        // height: 70,
        border: '1px solid #000000',
        borderRadius: '3px'
    },
    columnContainer: {
        padding: '2px',
        width: '100%'
    },
    label: {
        fontSize: 10,
        fontWeight: 'bold'
    }
});

const Address = ({ data }) => (
    <>
        <Text style={styles.reportTitle}>Endereço de entrega</Text>
        <View key={"container"} style={styles.fragmentContainer}>
            <View key={"collum"} style={styles.columnContainer}>
                <Text key={'address'} style={styles.label}>{data}</Text>
            </View>
        </View>
    </>
);

export default Address